<template>
  <div class="home-horizontal-scroll-functions">
    <van-swipe
      class="home-horizontal-scroll-functions-swipe-view"
      indicator-color="black"
    >
      <van-swipe-item v-for="(itemList, index) in functionLists" :key="index">
        <div class="home-horizontal-scroll-functions-swipe-view-item">
          <div v-for="(item, id) in itemList" :key="id" @click="routeTo(item)">
            <img v-if="item.icon" v-lazy="item.icon" alt="" />
            <div>
              {{ item.menuname }}
            </div>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    functionLists() {
      const functions = [];
      const tmplist = this.list;
      const pageSize = 5;
      // const pages = Math.ceil(this.list.length / pageSize)
      while (tmplist.length) {
        functions.push(tmplist.splice(0, pageSize));
      }
      return functions;
    }
  },
  methods: {
    routeTo(item) {
      if (item.menuname == "医保明细") {
        this.$http
          .post(this.$api.USER_BASE_INFO, {
            functionType: "1",
          })
          .then((info) => {
            this.$http.post(this.$api.MEDICAL_INSURANCE_QUERY, {
              functionType: "1",
              patientId: info.patientId,
              ybsxbs: "1",
            }).then((res) => {
              let a = document.createElement("a");
              a.href = res.ybUrl
              a.click();
            })
          });
      } else {
        this.$emit("routeTo", item);
      }
    }
  }
};
</script>
<style lang="less">
.home-horizontal-scroll-functions {
  height: 5rem;
  margin: 1rem 0;

  &-swipe-view {
    height: 6rem;
    .van-swipe__indicator {
      width: 0.8rem;
      background: gray;
      border-radius: 0.2rem;
    }

    &-item {
      display: flex;
      width: 100%;
      color: #050505;
      text-align: center;
      img {
        width: 43.5px;
      }
      > div {
        width: 20%;
        font-size: 0.75rem;
      }
    }
  }
}
</style>
